module.exports = __webpack_public_path__ + "public/images/slider/speaker-1-icon.3b14bb2743f391f41d25ab80f7211835.png";